import React from 'react';

const TotalRow = ({ data }) => {
    const style = { fontSize: '18px', fontWeight: 'bold', textAlign: 'center' };

    return (
        <tr>
            <td colSpan={2} style={style}>Total</td>
            <td style={style}>{data.spent}</td>
            <td style={style}>{data.impressions}</td>
            <td style={style}>{data.availableClicks}</td>
            <td style={style}>{data.clicks}</td>
            <td style={style}>{data.bid}</td>
            <td style={style}>{data.onwRevenue}</td>
            <td style={style}>{data.revenue}</td>
            <td style={style}>{data.totalRevenue}</td>
            <td style={style}>{data.roi}</td>
            <td style={style}>{data.roiPercent}</td>
            <td style={style}>{data.onwRoi}</td>
            <td style={style}>{data.winRate}</td>
        </tr>
    );
};

export default TotalRow;


// WEBPACK FOOTER //
// ./src/scenes/ZeroPark/components/Table/components/TotalRow/index.js